module.exports = __webpack_public_path__ + "static/media/fanzhh_wechat_shoukuan.c77d8f53.jpg";